import { Car, CarFront, Truck, Fuel, Weight, HardHat } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/business";

const TYPES = [
  { icon: Car, label: "Cars" },
  { icon: CarFront, label: "SUVs" },
  { icon: Truck, label: "Pickup Trucks" },
  { icon: Fuel, label: "Diesel Pickups" },
  { icon: Weight, label: "Dually Pickups" },
  { icon: HardHat, label: "Work Pickups" },
];

export const VehicleTypes = () => (
  <section className="relative py-24 md:py-32 overflow-hidden" data-testid="vehicle-types-section">
    <img src={IMAGES.steel} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-15" loading="lazy" />
    <div className="absolute inset-0 bg-[#0A0A0A]/70" />
    <div className="relative px-6 md:px-12 lg:px-24">
      <Reveal>
        <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">05 — What We Work On</p>
        <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="vehicle-types-heading">
          If It Drives, <span className="text-zinc-500">We Fix It.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {TYPES.map(({ icon: Icon, label }, i) => (
          <Reveal key={label} delay={i * 0.07}>
            <div className="group border border-zinc-700 bg-black/50 backdrop-blur-sm p-6 md:p-8 text-center hover:border-[#FF3B30] transition-colors duration-300" data-testid={`vehicle-type-${label.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon className="w-10 h-10 mx-auto text-zinc-300 group-hover:text-[#FF3B30] transition-colors duration-300" strokeWidth={1.25} />
              <p className="mt-4 font-oswald uppercase tracking-wide text-sm md:text-base">{label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
